import AuthLayout from '@authentication/components/AuthLayout';
import { LoginCard } from '@authentication/components/molecules/LoginCard';

export default function LoginPage() {
  return (
    <AuthLayout>
      <LoginCard />
    </AuthLayout>
  );
}
